import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { ILangInfo, LangEnum } from "@models/interface-management/localization";

@Injectable({
  providedIn: "root",
})
export class LocalizationService {
  public static settingItem: string = "show-select-lang";
  public static settingItemDefaultValue: boolean = true;

  private static currentLang = LangEnum.RU;
  private changeLang = new EventEmitter<LangEnum>();

  private readonly needTranslation = new BehaviorSubject<boolean>(false);

  constructor(private translate: TranslateService) {
    const browserLang = translate.getBrowserLang();
    const savedLang = localStorage.getItem("lang");

    if (!savedLang) {
      LocalizationService.currentLang = (
        browserLang.match(/en|ru|kz/) ? browserLang : "ru"
      ) as LangEnum;
    } else {
      LocalizationService.currentLang = savedLang as LangEnum;
    }

    localStorage.setItem("lang", LocalizationService.currentLang as string);

    const need = localStorage.getItem("needTranslation");

    if (need) {
      this.needTranslation.next(true);
    }
  }

  static getLang(): LangEnum {
    return LocalizationService.currentLang;
  }

  static getLangList(): ILangInfo[] {
    return [
      {
        shortName: "Рус",
        lang: LangEnum.RU,
      },
      {
        shortName: "Қаз",
        lang: LangEnum.KZ,
      },
      {
        shortName: "Eng",
        lang: LangEnum.EN,
      },
    ];
  }

  setLang(lang: LangEnum) {
    LocalizationService.currentLang = lang;
    this.translate.use(lang as string);
    this.changeLang.emit(lang);
    localStorage.setItem("lang", lang as string);
  }

  getCurrentLang() {
    return localStorage.getItem("lang");
  }

  subscribeCurrentLang(): Observable<LangEnum> {
    return this.changeLang.asObservable();
  }
}
